import React from "react";
import { Table, Button, Space, Modal, Form, Input, notification, Tabs, Image } from "antd";
import Editor from '@monaco-editor/react';
import { KeyVal } from "../Layouts";
import UploadMap from '../Project/UploadMap'
import IfNotObserver from "../common/IfNotObserver";

function Configs() {
    const [showModal, setShowModal] = React.useState(false);
    const [isRead, setIsRead] = React.useState(false);
    return (
        <div>
            <Space>
                <Input.Search />
                <IfNotObserver>
                    <Button type='primary' onClick={() => setShowModal(true)}>创建配置</Button>
                </IfNotObserver>

            </Space>
            <br /> <br />
            <Table
                columns={[
                    {
                        dataIndex: 'id',
                        title: 'ID',
                    },
                    {
                        dataIndex: 'name',
                        title: '名称',
                    },
                    {
                        dataIndex: 'desciption',
                        title: '备注',
                    },
                    {
                        dataIndex: 'createTime',
                        title: '创建时间',
                    },
                    {
                        dataIndex: 'createBy',
                        title: '创建人',
                    },
                    {
                        dataIndex: 'actions',
                        title: '操作',
                        render: () => {
                            return (
                                <Space size="middle">
                                    <a onClick={e => {
                                        e.preventDefault()
                                        setShowModal(true)
                                        setIsRead(true)
                                    }}>查看</a>
                                    <IfNotObserver>

                                        <a onClick={e => {
                                            e.preventDefault()
                                            setShowModal(true)
                                        }}>编辑</a>
                                        <a onClick={e => {
                                            e.preventDefault()
                                            Modal.confirm({
                                                title: '确定删除?',
                                                onOk: () => notification.success({ message: '操作成功' })
                                            })
                                        }}>删除</a>
                                    </IfNotObserver>
                                </Space>
                            )
                        }
                    }
                ]}
                dataSource={
                    new Array(20).fill(0).map((i, index) => {
                        return {
                            id: index,
                            name: 'App 轮播图配置-' + index,
                            desciption: '这是一个配置文件-' + index,
                            createTime: '2024-01-01 10:00',
                            createBy: '王元旭'
                        }
                    })
                }
            />
            <Modal width={800} title='创建/编辑配置' open={showModal} footer={null} onCancel={() => { setShowModal(false) }}>
                <br />
                <Form>
                    <Editor height={400} defaultLanguage="json" defaultValue={
                        `{
    "name": "app_banner",
    "description": "App 首页轮播图配置",
    "pics": [
        {
            "index": 0, 
            "url": "https://xxx.xxx/pic1.png"
        },
        {
            "index": 1, 
            "url": "https://xxx.xxx/pic2.png"
        }
    ]
}`} />
                    <Form.Item style={{ textAlign: 'center' }}>
                        <Button onClick={() => {
                            setShowModal(false)
                            if (!isRead) {
                                notification.success({ message: '操作成功' })
                            }
                            setIsRead(false)
                        }} type='primary'>确认</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    )
}

function Pics() {
    const [showModal, setShowModal] = React.useState(false);
    const [showCreate, setShowCreate] = React.useState(false);
    return (
        <div>
            <Space>
                <Input.Search />
                <Button type='primary' onClick={() => setShowCreate(true)}>上传文件</Button>
            </Space>
            <br /> <br />
            <Table
                columns={[
                    {
                        dataIndex: 'id',
                        title: 'ID',
                    },
                    {
                        dataIndex: 'url',
                        title: '缩略图',
                        render(url) {
                            return <Image width={50} src={url} />
                        }
                    },
                    {
                        dataIndex: 'url',
                        title: '链接',
                    },
                    {
                        dataIndex: 'desciption',
                        title: '备注',
                    },
                    {
                        dataIndex: 'createTime',
                        title: '创建时间',
                    },
                    {
                        dataIndex: 'createBy',
                        title: '创建人',
                    },
                    {
                        dataIndex: 'actions',
                        title: '操作',
                        render: () => {
                            return (
                                <Space size="middle">
                                    <a onClick={e => {
                                        e.preventDefault()
                                        setShowModal(true)
                                    }}>查看</a>
                                    <IfNotObserver>

                                        <a onClick={e => {
                                            e.preventDefault()
                                            Modal.confirm({
                                                title: '确定删除?',
                                                onOk: () => notification.success({ message: '操作成功' })
                                            })
                                        }}>删除</a>
                                    </IfNotObserver>
                                </Space>
                            )
                        }
                    }
                ]}
                dataSource={
                    new Array(20).fill(0).map((i, index) => {
                        return {
                            id: index,
                            url: 'http://www.shqyjzaz.com/icbms/locationinfo/viewImg/e8d1a322-0cad-4577-8225-62abd33fa26d.jpg',
                            desciption: '这是一张图片-' + index,
                            createTime: '2024-01-01 10:00',
                            createBy: '王元旭'
                        }
                    })
                }
            />
            <Modal title='详细信息' open={showModal} footer={null} onCancel={() => { setShowModal(false) }}>
                <br />
                <KeyVal name="格式" value={'PNG'} />
                <KeyVal name="链接" value={'http://www.shqyjzaz.com/icbms/locationinfo/viewImg/e8d1a322-0cad-4577-8225-62abd33fa26d.jpg'} />
                <KeyVal name="大小" value={'10m'} />
                <KeyVal name="上传时间" value={'2020-11-11 10:18'} />
                <KeyVal name="上传用户" value={'Robin'} />
                <Image src='http://www.shqyjzaz.com/icbms/locationinfo/viewImg/e8d1a322-0cad-4577-8225-62abd33fa26d.jpg'
                    width={200}
                />
            </Modal>
            <Modal title='上传文件' open={showCreate} onOk={() => {
                notification.success({ message: '创建成功' })
                setShowCreate(false)
            }} onCancel={() => { setShowCreate(false) }}>
                <Form>
                    <Form.Item label='文件'>
                        <UploadMap onFileChange={() => { }} />
                    </Form.Item>
                    <Form.Item label='备注'>
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    )
}

export default function Cms() {
    return (
        <Tabs defaultActiveKey="configs" items={[
            {
                key: 'pics',
                label: '图片/视频资源管理',
                children: <Pics />
            },
            {
                key: 'configs',
                label: '内容配置',
                children: <Configs />
            },
        ]}>
        </Tabs>
    )
}